import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { BREAKPOINTS } from '@ordermentum/ui-static';

const GridCardWrapperComponent = styled('div')`
  width: 100%;
  margin: 0 0 1rem;

  @media (min-width: ${BREAKPOINTS.TABLET_MIN}) {
    margin-right: 1rem;
    &:last-child {
      margin-right: 0;
    }
  }
`;

const RowWrapper = styled('div')<{ narrow?: boolean }>`
  label: row-wrapper;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row wrap;
  align-items: left;
  width: 100%;

  @media (min-width: ${BREAKPOINTS.TABLET_MIN}) {
    margin-right: 1rem;
    margin-bottom: ${p => (p.narrow ? '0' : '1rem')};
    &:last-child {
      margin-right: 0;
    }
  }
`;

const CellWrapper = styled('div')`
  label: cell-wrapper;
  display: flex;
  flex-grow: 1;
  max-width: 100%;
  flex-basis: 0;
  position: relative;
  width: 100%;
  min-height: 1px;
  margin-bottom: 1rem;

  & + & {
    margin-left: 1rem;
  }

  @media (min-width: ${BREAKPOINTS.TABLET_MIN}) {
    margin-right: 1rem;
    &:last-child {
      margin-right: 0;
    }
  }
`;

const Cell = (props: { children: ReactNode }) => (
  <CellWrapper>{props.children}</CellWrapper>
);

const Row = (props: { children: ReactNode } & { narrow?: boolean }) => (
  <RowWrapper narrow={props.narrow}>{props.children}</RowWrapper>
);

const GridCardWrapper = (props: { children: ReactNode }) => (
  <GridCardWrapperComponent>{props.children}</GridCardWrapperComponent>
);

export { Row, Cell, GridCardWrapper };
